import { ThunkResult } from '../../../store'
import { replaceResult } from './ConsumedCases.slice'
import consumedApi from '../../../apis/consumed.api'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().consumedCases
    const params = { page, limit, search }
    consumedApi.paginateCase(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}
